<div class="modal-header">
	<h5 class="modal-title">Witterung</h5>
	<button type="button" class="btn-close" aria-label="Schließen" (click)="activeModal.dismiss()"></button>
</div>
<div class="modal-body">
	<!-- Hilfetext -->
	<div class="help-text mb-3">
		<p>Automatisch abgerufene Wetterdaten von Open-Meteo.</p>
	</div>

	<!-- Einstellungen nur für berechtigte Benutzer -->
	@if (canEdit) {
		<div class="accordion" id="weatherConfigAccordion">
			<!-- Temperatur -->
			<div class="accordion-item">
				<h2 class="accordion-header">
					<button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#tempSection">
						Temperatur (°C)
					</button>
				</h2>
				<div id="tempSection" class="accordion-collapse collapse" data-bs-parent="#weatherConfigAccordion">
					<div class="accordion-body">
						<div class="row g-2">
							<div class="col-3">
								<label class="form-label">frostig &lt;</label>
								<input type="number" class="form-control form-control-sm" [(ngModel)]="config.temperature.frostig">
							</div>
							<div class="col-3">
								<label class="form-label">kalt &lt;</label>
								<input type="number" class="form-control form-control-sm" [(ngModel)]="config.temperature.kalt">
							</div>
							<div class="col-3">
								<label class="form-label">kühl &lt;</label>
								<input type="number" class="form-control form-control-sm" [(ngModel)]="config.temperature.kuehl">
							</div>
							<div class="col-3">
								<label class="form-label">mild &lt;</label>
								<input type="number" class="form-control form-control-sm" [(ngModel)]="config.temperature.mild">
							</div>
							<div class="col-3">
								<label class="form-label">warm &lt;</label>
								<input type="number" class="form-control form-control-sm" [(ngModel)]="config.temperature.warm">
							</div>
						</div>
					</div>
				</div>
			</div>

			<!-- Niederschlag -->
			<div class="accordion-item">
				<h2 class="accordion-header">
					<button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#precipSection">
						Niederschlag (mm/Tag)
					</button>
				</h2>
				<div id="precipSection" class="accordion-collapse collapse" data-bs-parent="#weatherConfigAccordion">
					<div class="accordion-body">
						<div class="row g-2">
							<div class="col-3">
								<label class="form-label">trocken &lt;</label>
								<input type="number" class="form-control form-control-sm" [(ngModel)]="config.precipitation.trocken">
							</div>
							<div class="col-3">
								<label class="form-label">leicht feucht &lt;</label>
								<input type="number" class="form-control form-control-sm" [(ngModel)]="config.precipitation.leichtFeucht">
							</div>
							<div class="col-3">
								<label class="form-label">feucht &lt;</label>
								<input type="number" class="form-control form-control-sm" [(ngModel)]="config.precipitation.feucht">
							</div>
						</div>
					</div>
				</div>
			</div>

			<!-- Bewölkung -->
			<div class="accordion-item">
				<h2 class="accordion-header">
					<button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#cloudSection">
						Bewölkung (%)
					</button>
				</h2>
				<div id="cloudSection" class="accordion-collapse collapse" data-bs-parent="#weatherConfigAccordion">
					<div class="accordion-body">
						<div class="row g-2">
							<div class="col-3">
								<label class="form-label">heiter &lt;</label>
								<input type="number" class="form-control form-control-sm" [(ngModel)]="config.cloudCover.heiter">
							</div>
							<div class="col-3">
								<label class="form-label">leicht bewölkt &lt;</label>
								<input type="number" class="form-control form-control-sm" [(ngModel)]="config.cloudCover.leichtBewoelkt">
							</div>
							<div class="col-3">
								<label class="form-label">bewölkt &lt;</label>
								<input type="number" class="form-control form-control-sm" [(ngModel)]="config.cloudCover.bewoelkt">
							</div>
						</div>
					</div>
				</div>
			</div>

			<!-- Wind -->
			<div class="accordion-item">
				<h2 class="accordion-header">
					<button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#windSection">
						Wind (km/h)
					</button>
				</h2>
				<div id="windSection" class="accordion-collapse collapse" data-bs-parent="#weatherConfigAccordion">
					<div class="accordion-body">
						<div class="row g-2">
							<div class="col-3">
								<label class="form-label">windstill &lt;</label>
								<input type="number" class="form-control form-control-sm" [(ngModel)]="config.windSpeed.windstill">
							</div>
							<div class="col-3">
								<label class="form-label">leicht &lt;</label>
								<input type="number" class="form-control form-control-sm" [(ngModel)]="config.windSpeed.leicht">
							</div>
							<div class="col-3">
								<label class="form-label">mäßig &lt;</label>
								<input type="number" class="form-control form-control-sm" [(ngModel)]="config.windSpeed.maessig">
							</div>
							<div class="col-3">
								<label class="form-label">stark &lt;</label>
								<input type="number" class="form-control form-control-sm" [(ngModel)]="config.windSpeed.stark">
							</div>
						</div>
					</div>
				</div>
			</div>

			<!-- Luftfeuchtigkeit -->
			<div class="accordion-item">
				<h2 class="accordion-header">
					<button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#humiditySection">
						Luftfeuchtigkeit (%)
					</button>
				</h2>
				<div id="humiditySection" class="accordion-collapse collapse" data-bs-parent="#weatherConfigAccordion">
					<div class="accordion-body">
						<div class="row g-2">
							<div class="col-3">
								<label class="form-label">sehr trocken &lt;</label>
								<input type="number" class="form-control form-control-sm" [(ngModel)]="config.humidity.sehrTrocken">
							</div>
							<div class="col-3">
								<label class="form-label">normal &lt;</label>
								<input type="number" class="form-control form-control-sm" [(ngModel)]="config.humidity.normal">
							</div>
							<div class="col-3">
								<label class="form-label">feucht &lt;</label>
								<input type="number" class="form-control form-control-sm" [(ngModel)]="config.humidity.feucht">
							</div>
							<div class="col-3">
								<label class="form-label">schwül ab °C</label>
								<input type="number" class="form-control form-control-sm" [(ngModel)]="config.humidity.schwuelMinTemp">
							</div>
						</div>
					</div>
				</div>
			</div>

			<!-- Bodenzustand -->
			<div class="accordion-item">
				<h2 class="accordion-header">
					<button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#soilSection">
						Bodenzustand (mm/{{config.soil.tage}} Tage)
					</button>
				</h2>
				<div id="soilSection" class="accordion-collapse collapse" data-bs-parent="#weatherConfigAccordion">
					<div class="accordion-body">
						<div class="row g-2">
							<div class="col-3">
								<label class="form-label">Tage</label>
								<input type="number" min="1" max="14" class="form-control form-control-sm" [(ngModel)]="config.soil.tage">
							</div>
							<div class="col-3">
								<label class="form-label">trocken &lt;</label>
								<input type="number" class="form-control form-control-sm" [(ngModel)]="config.soil.trocken">
							</div>
							<div class="col-3">
								<label class="form-label">leicht feucht &lt;</label>
								<input type="number" class="form-control form-control-sm" [(ngModel)]="config.soil.leichtFeucht">
							</div>
							<div class="col-3">
								<label class="form-label">feucht &lt;</label>
								<input type="number" class="form-control form-control-sm" [(ngModel)]="config.soil.feucht">
							</div>
							<div class="col-3">
								<label class="form-label">nass &lt;</label>
								<input type="number" class="form-control form-control-sm" [(ngModel)]="config.soil.nass">
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	} @else {
		<!-- Nur Anzeige der aktuellen Schwellwerte für normale Benutzer -->
		<div class="current-config">
			<h6>Aktuelle Schwellwerte</h6>
			<table class="table table-sm">
				<tbody>
					<tr>
						<td>Temperatur</td>
						<td>frostig &lt;{{config.temperature.frostig}}°C, kalt &lt;{{config.temperature.kalt}}°C, kühl &lt;{{config.temperature.kuehl}}°C, mild &lt;{{config.temperature.mild}}°C, warm &lt;{{config.temperature.warm}}°C</td>
					</tr>
					<tr>
						<td>Niederschlag</td>
						<td>trocken &lt;{{config.precipitation.trocken}}mm, leicht feucht &lt;{{config.precipitation.leichtFeucht}}mm, feucht &lt;{{config.precipitation.feucht}}mm</td>
					</tr>
					<tr>
						<td>Bewölkung</td>
						<td>heiter &lt;{{config.cloudCover.heiter}}%, leicht bewölkt &lt;{{config.cloudCover.leichtBewoelkt}}%, bewölkt &lt;{{config.cloudCover.bewoelkt}}%</td>
					</tr>
					<tr>
						<td>Wind</td>
						<td>windstill &lt;{{config.windSpeed.windstill}}km/h, leicht &lt;{{config.windSpeed.leicht}}km/h, mäßig &lt;{{config.windSpeed.maessig}}km/h, stark &lt;{{config.windSpeed.stark}}km/h</td>
					</tr>
					<tr>
						<td>Luftfeuchte</td>
						<td>sehr trocken &lt;{{config.humidity.sehrTrocken}}%, normal &lt;{{config.humidity.normal}}%, feucht &lt;{{config.humidity.feucht}}%, schwül ab {{config.humidity.schwuelMinTemp}}°C</td>
					</tr>
					<tr>
						<td>Boden</td>
						<td>{{config.soil.tage}} Tage: trocken &lt;{{config.soil.trocken}}mm, leicht feucht &lt;{{config.soil.leichtFeucht}}mm, feucht &lt;{{config.soil.feucht}}mm, nass &lt;{{config.soil.nass}}mm</td>
					</tr>
				</tbody>
			</table>
		</div>
	}
</div>
<div class="modal-footer">
	@if (hasRawData) {
		<button type="button" class="btn btn-outline-info me-auto" (click)="reinterpret()" title="Witterungstext aus gespeicherten Rohdaten mit aktuellen Schwellwerten neu generieren">
			<i class="bi bi-arrow-repeat"></i> Neu interpretieren
		</button>
	}
	@if (canEdit) {
		<button type="button" class="btn btn-outline-secondary" (click)="resetToDefaults()">
			<i class="bi bi-arrow-counterclockwise"></i> Zurücksetzen
		</button>
		<button type="button" class="btn btn-primary" (click)="save()">
			<i class="bi bi-check-lg"></i> Speichern
		</button>
	}
	<button type="button" class="btn btn-secondary" (click)="activeModal.dismiss()">Schließen</button>
</div>
